import { useGetMe } from "@entities/Onboarding/lib/hooks/useGetMe";
import { useCreateReport } from "@entities/reports/lib/hooks/useCreateReport";
import { useGetReports } from "@entities/reports/lib/hooks/useGetReports";
import { ReportForm } from "@entities/reports/ui/ReportForm";
import { ReportsTable } from "@entities/reports/ui/ReportsTable";
import { ToastService } from "@shared/lib/services";
import { Button, Input, Modal, TableTitleLayout } from "@shared/ui";
import { DisabledPopover } from "@shared/ui/DisabledPopover";
import { Flex } from "antd";
import { Plus, Search, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import styles from "./styles.module.scss";

export function ReportsPage() {
  const [searchQuery, setSearchQuery] = useState("");
  const { userDetails } = useGetMe();
  const isCreateReportButtonDisabled = false;

  const [debouncedSearchQuery] = useDebounce(searchQuery, 500);
  const [pageNo, setPageNo] = useState<number>(1);
  const [pageSize] = useState(10);

  const { reports, isFetching } = useGetReports(
    debouncedSearchQuery,
    pageSize,
    pageNo
  );

  const { crateReport, isLoading: isCreating, isCreated } = useCreateReport();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  useEffect(() => {
    if (isCreated) {
      ToastService.success("Report created successfully");
      setIsCreateModalOpen(false);
      setPageNo(1);
      setSearchQuery("");
    }
  }, [isCreated]);

  return (
    <div className={styles.reportsPage}>
      <div className={styles.pageContent}>
        <div className={styles.header}>
          <div>
            <h1 className={styles.title}>Reports</h1>
            {/* <p className={styles.subtitle}>
              Manage and analyze performance across all your campaigns.
            </p> */}
          </div>
        </div>

        <ReportsTable
          reports={reports?.data || []}
          isFetching={isFetching}
          pageNo={pageNo}
          pageSize={pageSize}
          totaldata={reports?.pagination?.totalCount || 0}
          onPageChange={(page) => setPageNo(page)}
          totalPages={reports?.pagination?.totalPages || 0}
          title={
            <TableTitleLayout 
            filterComponent={
              <Flex style={{width: "100%"}} justify="space-between">
            <Input
            placeholder="Search reports..."
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setPageNo(1);
              }}
              prefix={<Search size={16} className={styles.searchIcon} />}
              className={styles.searchInput}
          />
          <DisabledPopover isDisabled={isCreateReportButtonDisabled}>
              <Button
                type="primary"
                disabled={isCreateReportButtonDisabled}
                icon={<Plus size={16} />}
                className={styles.createReportButton}
                onClick={() => setIsCreateModalOpen(true)}
              >
                Create New Report
              </Button>
            </DisabledPopover>
          </Flex>}
          totalText={`${reports?.pagination?.totalCount || 0} results found`}
        />}
        />

      <Modal
        open={isCreateModalOpen}
        onCancel={() => setIsCreateModalOpen(false)}
        footer={null}
        width={520}
        className={styles.createReportModal}
        styles={{
          body: { padding: 0 },
          header: { marginBottom: 0, padding: 0, borderBottom: 0 },
        }}
        title={null}
        closeIcon={null}
      >
        <div className={styles.modalContent}>
          <div className={styles.modalHeader}>
            <h3 className={styles.modalTitle}>Create Custom Report</h3>
            <button
              onClick={() => setIsCreateModalOpen(false)}
              className={styles.closeButton}
              type="button"
            >
              <X size={20} />
            </button>
          </div>

          <ReportForm
            onSubmit={(report) => {
              crateReport({
                name: report.name,
                updateForIntervalHourFrequency:
                  report.updateForIntervalHourFrequency,
                updateTillDate: report.updateTillDate,
              });
            }}
            isSubmitting={isCreating}
            onCancel={() => setIsCreateModalOpen(false)}
          />
        </div>
      </Modal>
    </div>
    </div>
  );
}
